var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view" },
    [
      _vm.isSplash
        ? [
            _c("div", { staticClass: "splash" }, [
              _c("div", { staticClass: "logo", attrs: { id: "logo" } }, [
                _c("img", {
                  attrs: { src: require("./assets/logo.png").default }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "menu" }, [
                _c("div", { staticClass: "corner corner-tl" }),
                _vm._v(" "),
                _c("div", { staticClass: "corner corner-tr" }),
                _vm._v(" "),
                _c("div", { staticClass: "corner corner-bl" }),
                _vm._v(" "),
                _c("div", { staticClass: "corner corner-br" }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "menu-item",
                    staticStyle: { display: "none", "text-align": "center" },
                    attrs: { id: "innerLogo" }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("./assets/logo.png").default,
                        width: "120px"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "menu-item",
                    on: {
                      click: function($event) {
                        return _vm.onStartGame("sam2_kor", "KOEI.BAT", [
                          "1",
                          "2",
                          "3",
                          "4",
                          "5"
                        ])
                      }
                    }
                  },
                  [_vm._v("삼국지2 한글판 플레이")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "menu-item",
                    on: {
                      click: function($event) {
                        return _vm.onStartGame("sam2_eng", "KOEI.BAT", [
                          "1",
                          "2",
                          "3",
                          "4",
                          "5"
                        ])
                      }
                    }
                  },
                  [_vm._v("삼국지2 영문판 플레이")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "menu-item",
                    on: {
                      click: function($event) {
                        return _vm.onStartGame("sam3", "KOEI.COM", [
                          "SANGOKU3.SAV",
                          "NBDATA.DAT"
                        ])
                      }
                    }
                  },
                  [_vm._v("삼국지3 플레이")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "menu-item",
                    on: {
                      click: function($event) {
                        return _vm.onStartGame("sam4pk", "sam4.bat", [
                          "SAVEDAT.S4",
                          "NBDATA.S4"
                        ])
                      }
                    }
                  },
                  [_vm._v("삼국지4pk 플레이")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "menu-item",
                    on: {
                      click: function($event) {
                        return _vm.onStartGame("hero", "hero.com", [
                          "MSAVE0.R3S",
                          "ESAVE0.R3S",
                          "MSAVE1.R3S",
                          "ESAVE1.R3S",
                          "MSAVE2.R3S",
                          "ESAVE2.R3S",
                          "MSAVE3.R3S",
                          "ESAVE3.R3S",
                          "MSAVE4.R3S",
                          "ESAVE4.R3S"
                        ])
                      }
                    }
                  },
                  [_vm._v("삼국지 영걸전 플레이")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "menu-item",
                    on: {
                      click: function($event) {
                        return _vm.onStartGame("suho", "koei.com", ["SAVEDATA"])
                      }
                    }
                  },
                  [_vm._v("수호전 플레이[비번:10000]")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "menu-item",
                    on: {
                      click: function($event) {
                        return _vm.onStartGame("khan3", "koei.com", [
                          "SAVEDATA.GK2"
                        ])
                      }
                    }
                  },
                  [_vm._v("징기스칸3 플레이")]
                )
              ]),
              _vm._v(" "),
              _vm._m(0)
            ])
          ]
        : [
            _c("Game", {
              attrs: {
                mod: _vm.gameMod || undefined,
                entry: _vm.gameEntry || undefined,
                save: _vm.gameSave || undefined,
                dbx: _vm.dbx
              }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticStyle: { color: "white", padding: "10px" },
        attrs: { id: "notice" }
      },
      [
        _vm._v('※ 삼국지2 에서 게임 저장하실 때 ("1" ~ "5")로 저장'),
        _c("br"),
        _vm._v("\n        ※ 삼국지4, 영걸전 - 마우스 가능"),
        _c("br")
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }